"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ContentCopy_1 = __importDefault(require("@mui/icons-material/ContentCopy"));
const material_1 = require("@mui/material");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const requestDetail_1 = require("../../request/newRequest/requestDetail");
const virtualCard_1 = require("../../request/virtualCard");
const truncatedRequesterFullNameText_1 = __importDefault(require("../component/truncatedRequesterFullNameText"));
const walletCard_1 = require("../walletDetails/walletCard");
function getCardProvider(card) {
    if (lodash_1.default.isEmpty(card)) {
        return 'N/A';
    }
    return card.provider;
}
const MyCardItemContent = ({ task }) => {
    const [isHovering, setIsHovering] = (0, react_1.useState)(false);
    const [copyDetails, setCopyDetails] = (0, react_1.useState)({ isCopied: false, copySuccessMessage: '' });
    const theme = (0, material_1.useTheme)();
    const cardNumber = (0, virtualCard_1.getCardNumber)(task.card);
    const requesterFullName = (0, react_1.useMemo)(() => (lodash_1.default.isEmpty(task.request) ? '' : (0, requestDetail_1.getFullName)(task.request.requester)), [task.request]);
    const cardProvider = getCardProvider(task.card);
    const isAmexCardProvider = cardProvider === 'AMEX';
    const isCopyAllowed = !Number.isNaN(Number(cardNumber));
    const formattedExpirationDate = (0, virtualCard_1.getFormattedExpiration)(task.card?.expirationDate);
    const copyItems = {
        number: {
            name: 'card number',
            data: cardNumber,
        },
        cvc: {
            name: walletCard_1.cvv2OrCvc,
            data: (0, virtualCard_1.getCVVNumber)(task.card, cardProvider || ''),
        },
    };
    const setCopyItem = (copyItemKey, event) => {
        event.stopPropagation();
        if (!copyItems[copyItemKey] || !isCopyAllowed) {
            return;
        }
        const copyItem = copyItems[copyItemKey];
        setIsHovering(true);
        setCopyDetails({
            isCopied: false,
            copySuccessMessage: 'Copied ' + copyItem.name + '!',
        });
    };
    async function onCopySuccess(copyItemKey, event) {
        event.stopPropagation();
        if (!copyItems[copyItemKey] || !isCopyAllowed) {
            return;
        }
        const copyItem = copyItems[copyItemKey];
        await navigator.clipboard.writeText(copyItem.data);
        setCopyDetails({
            isCopied: true,
            copySuccessMessage: 'Copied ' + copyItem.name + '!',
        });
    }
    return ((0, jsx_runtime_1.jsxs)(virtualCard_1.StyledCard, { "data-testid": "my-card-content", onClick: event => onCopySuccess('number', event), sx: { cursor: isCopyAllowed && isHovering ? 'pointer' : 'default' }, children: [isAmexCardProvider ? (lodash_1.default.isEmpty(task.card) ? null : ((0, jsx_runtime_1.jsx)(virtualCard_1.StyledChip, { label: (0, virtualCard_1.getVirtualCardStatusAndLabel)({ card: task.card, fields: task.context?.request.fields }), color: (0, virtualCard_1.isActive)(task?.card) ? 'success' : 'error' }))) : null, (0, jsx_runtime_1.jsx)(virtualCard_1.StyledHoverText, { children: isCopyAllowed && isHovering ? (copyDetails.isCopied ? copyDetails.copySuccessMessage : '') : '' }), (0, jsx_runtime_1.jsxs)(virtualCard_1.StyledGrid, { onMouseOver: event => setCopyItem('number', event), onMouseOut: () => setIsHovering(false), className: isCopyAllowed ? 'isRevealDetailsAllowed' : '', children: [(0, virtualCard_1.formatCardNumber)(task.card).map((cardNumberPiece, index) => ((0, jsx_runtime_1.jsx)(material_1.Typography, { sx: [
                            {
                                fontSize: '18px',
                            },
                            globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    textShadow: '1px 1px hsl(204, 25%, 8%)',
                                    color: 'hsl(0, 0%, 100%)',
                                    marginRight: '-2.75px',
                                }
                                : {},
                        ], children: cardNumberPiece }, cardNumberPiece + index))), isCopyAllowed && ((0, jsx_runtime_1.jsx)(ContentCopy_1.default, { sx: {
                            fontSize: theme.typography.pxToRem(14),
                            color: 'hsl(0, 0%, 100%)',
                            marginLeft: theme.tsGoUnit.tsUnitQuarter,
                        } }))] }), (0, jsx_runtime_1.jsxs)(virtualCard_1.StyledBox, { children: [formattedExpirationDate ? ((0, jsx_runtime_1.jsxs)(virtualCard_1.StyledElement, { children: [walletCard_1.expirationLabel ? (0, jsx_runtime_1.jsx)(virtualCard_1.ExpirationLabel, { children: walletCard_1.expirationLabel }) : null, (0, jsx_runtime_1.jsx)(virtualCard_1.ExpirationValue, { "data-testid": "expirationDate", children: formattedExpirationDate })] })) : null, (0, jsx_runtime_1.jsxs)(virtualCard_1.StyledElement, { onMouseOver: event => setCopyItem('cvc', event), onMouseOut: () => setIsHovering(false), onClick: event => onCopySuccess('cvc', event), sx: { display: 'flex', justifyContent: 'flex-end' }, children: [(0, jsx_runtime_1.jsx)(virtualCard_1.ExpirationLabel, { children: walletCard_1.cvv2OrCvc }), (0, jsx_runtime_1.jsx)(virtualCard_1.ExpirationValue, { children: (0, virtualCard_1.getCVVNumber)(task.card, cardProvider || '') }), isCopyAllowed && ((0, jsx_runtime_1.jsx)(ContentCopy_1.default, { sx: { fontSize: theme.typography.pxToRem(14), color: 'hsl(0, 0%, 100%)' } }))] })] }), (0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, sx: { display: 'flex', justifyContent: 'space-between' }, children: [requesterFullName ? (0, jsx_runtime_1.jsx)(truncatedRequesterFullNameText_1.default, { text: requesterFullName }) : null, globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(material_1.Grid, { size: 2, children: (0, jsx_runtime_1.jsx)(virtualCard_1.ProviderImage, { provider: cardProvider || 'N/A' }) })) : null] })] }));
};
exports.default = MyCardItemContent;
